module.exports = __webpack_public_path__ + "img/sale-button-02.386d6141.png";